import { BadgeField, BooleanField, useFieldHelper, VersionField } from 'framework/ui/field';
import {
  ComplianceDocumentStatusTypes,
  ComplianceDocumentType,
  ComplianceDocumentTypeField,
  COMPLIANCE_DOCUMENT_STATUS,
} from 'domain/shared/compliance';
import { Typography } from '@mui/material';
import { Row } from 'framework/list';
import ComplianceDocumentListActions from '../shared/buttons/actions/ComplianceDocumentListActions';
import { Badge } from 'framework/ui/mui-builder';
import { ComplianceDocumentTargetAudienceField, getDocumentStatusView } from 'domain/shared/compliance';

export const ComplianceRegistryRow = () => {
  const { getValue } = useFieldHelper<ComplianceDocumentType[]>({ source: 'metadata.previousVersions' });
  const { getValue: getStatus } = useFieldHelper<ComplianceDocumentStatusTypes>({ source: 'metadata.status' });
  const previousVersions = getValue() || [];
  const currentStatus = getStatus();

  const isMainActive = currentStatus !== COMPLIANCE_DOCUMENT_STATUS.PUBLISHED;
  let isShowedActive = !isMainActive;

  return previousVersions.map(item => {
    const showPrevActive =
      isMainActive && item.metadata.status === COMPLIANCE_DOCUMENT_STATUS.PUBLISHED && !isShowedActive;
    const statusView = getDocumentStatusView(item.metadata.status, { isOutdated: !showPrevActive });

    if (showPrevActive) {
      isShowedActive = true;
    }
    return (
      <Row
        data={item}
        rowProps={{
          sx: {
            opacity: showPrevActive ? '1' : '0.4',
          },
        }}
        buttons={[<ComplianceDocumentListActions isPrevious />]}
        template={[
          //@ts-ignore template additional types
          <Typography source="space" label="" width="3%" />,

          //@ts-ignore template additional types
          <Typography width="24%" label="Name" source="space" />,

          <ComplianceDocumentTypeField width="17%" label="Type" source="metadata.complianceType" />,

          <VersionField width="8%" source="metadata.version" label="Version" />,

          <BadgeField
            width="12%"
            source="metadata.status"
            label="Status"
            badges={[<Badge color={statusView.color}>{statusView.label}</Badge>]}
          />,

          <BooleanField source="isPolicySigned" label="Signing" width="8%" />,

          <ComplianceDocumentTargetAudienceField label="Target audience" width="28%" isOutdated={!showPrevActive} />,
        ]}
      />
    );
  });
};
